import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'unite-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    imports: [MatDialogTitle, TranslateModule, MatDialogActions, MatButton, MatDialogClose]
})
export class DeleteDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public message: string) { }


}
